import { definePreset } from '@primeng/themes'
import Aura from '@primeng/themes/aura'

export const PrimeNgCustomPreset = definePreset(Aura, {
  semantic: {},
  components: {},
})
